<div
	*ngIf="show"
	class="d-flex justify-content-center align-items-center loading-overlay"
>
	<div *ngIf="!showOnlyBg" class="text-center">
		<div class="img-container">
			<svg
				*ngIf="showSpinner"
				class="spinner-container"
				width="80"
				height="80"
				viewBox="0 0 80 80"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<circle class="spinner-circle" cx="40" cy="40" r="38"></circle>
			</svg>
			<img
				class="max-size-logo"
				[class.fade]="showFade"
				[class.img-spinner]="showSpinner"
				[src]="image"
				alt="Logo base"
			/>
		</div>
		<div [class.less-opacity]="showFade">
			<h3 class="text-primary">{{ title }}</h3>
		</div>
		<div [class.less-opacity]="showFade">
			<h4 class="text-primary">{{ subtitle }}</h4>
		</div>
	</div>
</div>
